import Vue from 'vue'
import App from './App.vue'
import './assets/css/style.css'
import xvueui from 'xvue-ui'
import axios from 'axios'
import emailjs from 'emailjs-com' 
import apiKeys from './apikeys' 
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(VideoPlayer);
Vue.prototype.$ajax = axios
axios.defaults.baseURL='/apis'

Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

// const sendEmail = e => { 
//   e.preventDefault() 
 
  // emailjs 
  //   .sendForm('service_9ui26ik', apiKeys.TEMPLATE_ID, e.target, apiKeys.USER_ID) 
  //   .then( 
  //     result => { 
  //       console.log(result.text) 
  //     }, 
  //     error => { 
  //       console.log(error.text) 
  //     } 
  //   ) 
// } 

// import style (>= Swiper 6.x)
 import VueI18n from 'vue-i18n'
 Vue.use(VueI18n)
 const i18n = new VueI18n({
     locale: 'chj', // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
     messages: {
       'chf': require('./assets/languages/chf.json'),  // 本地资源文件，我这里配2个语言，中文&英文，src下根据个人情况放置
       'chj': require('./assets/languages/chj.json'),
       'en': require('./assets/languages/en.json')
     }
 });

import 'swiper/swiper-bundle.css'
import Swiper, { Pagination, Navigation,Autoplay,EffectFade} from 'swiper'
Swiper.use([Pagination, Navigation,Autoplay,EffectFade ])
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueAwesomeSwiper)
// import style (<= Swiper 5.x)
// import 'swiper/css/swiper.css'

// Vue.use(VueAwesomeSwiper)
Vue.use(xvueui)
Vue.config.productionTip = false
import router from './router'
import store from './store'
new Vue({
	router,
	i18n,
	store,
	render: h => h(App),
}).$mount('#app')
